import Flex from './Flex';
import './Flex.less';

export default Flex;
